import { createSlice, PayloadAction } from "@reduxjs/toolkit";
//import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import {
  InfoBookingApiError,
  InputErrors,
} from "../../common/types/errors.types";
//import { appInsights } from '../../app/AppInsights';
import { RootState } from "../../app/store";

interface ErrorState {
  apiError: InfoBookingApiError;
  inputErrors: InputErrors;
}

const initialState = { apiError: null, inputErrors: null } as ErrorState;

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    setApiError(state, action: PayloadAction<InfoBookingApiError>) {
      state.apiError = action.payload;
      /*
            if (action.payload) {
              const error: Error = {
                name: "InfoBooking API Exception",
                message: action.payload?.Exception,
              };

              const info = {
                source: action.payload?.Source,
                infoBookingErrorId: action.payload?.InfoBookingErrorId,
              };

                      const exceptionTelemetry: IExceptionTelemetry = {
                          exception: error,
                          properties: { ...info },
                      };

                      appInsights.trackException(exceptionTelemetry, info);

      }
       */
    },
    setInputErrors(state, action: PayloadAction<InputErrors>) {
      state.inputErrors = action.payload;
    },
    clearInputErrors(state) {
      state.inputErrors = null;
    },
  },
});

export const { setApiError, setInputErrors, clearInputErrors } =
  errorsSlice.actions;

export const selectInputErrors = (state: RootState) => state.errors.inputErrors;

export default errorsSlice.reducer;
